/**
 * check if url is valid or not
 * @param url
 * @returns
 */
export const isValidUrl = (url: string): boolean => {
  const sanitizedUrl: string = sanitizeUrl(url);
  try {
    new globalThis.URL(sanitizedUrl);
    return true;
  } catch (err) {
    return false;
  }
};

/**
 * it will add https protocol if protocol is not added in utl
 * @param url
 * @returns
 */
export function sanitizeUrl(url: string): string {
  if (!url) {
    return url;
  }

  // if any url not contain protocol then add https
  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    return `https://${url}`;
  }
  return url;
}

export function getServiceUrl(service: string, domain: string): string {
  const prefix: string = `https://`;
  const suffix: string = `.${domain}`;
  return `${prefix}${service}${suffix}`;
}
